import { Image, Text } from '@bitrise/bitkit';
import React, { FunctionComponent } from 'react';

import dataAtIds from '../../../../../../dataAtIds.json';
import Guide from '../../Guide';
import GuideStep from '../../GuideStep';
import GuideBitriseStep1 from './GuideBitriseStep.1.png';
import GuideBitriseStep2 from './GuideBitriseStep.2.png';
import GuideBitriseStep3 from './GuideBitriseStep.3.png';
import GuideBitriseStep4 from './GuideBitriseStep.4.png';

const GuideAndroidBitriseStep: FunctionComponent = () => (
  <Guide data-trace-at-id={dataAtIds.GettingStartedGuideAndroidBitriseStep} name="step">
    <GuideStep heading="Open the Workflow Editor" number="1">
      <Text>Open the Workflow you use to build the app in the Bitrise Workflow Editor.</Text>

      <Image borderRadius="x2" elevation="x1" src={GuideBitriseStep1} width="400px" />
    </GuideStep>

    <GuideStep heading="Add the Trace SDK Step" number="2">
      <Text>Add the Add Trace SDK Step before the Step that builds your app binary.</Text>

      <Image borderRadius="x2" elevation="x1" src={GuideBitriseStep2} width="400px" />
    </GuideStep>

    <GuideStep heading="Double check an Environment Variable" number="3">
      <Text>
        Check that the Project (or Workspace) path input value is correct. By default, the value is
        the Environment Variable which is created and stored at the creation of the app.
      </Text>

      <Image borderRadius="x2" elevation="x1" src={GuideBitriseStep3} width="400px" />
    </GuideStep>

    <GuideStep heading="Now you can run it!" number="4">
      <Text>
        All that is left now is to Schedule a build and run the app in the simulator or a device.
      </Text>

      <Image borderRadius="x2" elevation="x1" src={GuideBitriseStep4} width="400px" />

      <Text>
        Provided there are no errors, your app will be reporting performance data. Feel free to play
        around the app to generate more sample data.
      </Text>
    </GuideStep>
  </Guide>
);

export default GuideAndroidBitriseStep;
